import styled from 'styled-components';

export const BaseLoading = styled.div`
  && {
    height: 100%;
    width: 100%;
  }
`;
